import React, { useState, useEffect, useRef, useCallback } from "react";
import config from "../../../../../config";
import ViewPdfModal from "./view-pdf";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import Axios from "axios";
import Pusher from "pusher-js";
import { TrackJS } from "trackjs";
import { getPdfUrl } from "../../../../../components/helper/helper";
import momentTimezone from "moment-timezone";
import Spinner from "../../../../components/Loaders/Spinner";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Button from "../../../../components/new-button";
import {
  getPdfStatus,
  signatureLocations,
  getApplicationData,
} from "../../../../../api/index";
import styles from "./style.module.scss";
// import "./style.scss";
import useSalesFormStore from "../../../../stores/sales-form";

const stratusURL = config.paymentcloud.STRATUS_URL;

const SignatureTooltip =
  "Please draw a signature and agree to terms and conditions";

const DigitalSignature = (props) => {
  const { viewOnly, progressId } = props;
  const [pdf, setPdf] = useState();
  const [pdfList, setPdfList] = useState([]);
  const [viewedPdfList, setViewdPdfList] = useState([]);
  const [checkedPdfList, setCheckedPdfList] = useState([]);
  const [eSingendPdf, setESignedPdf] = useState({});
  const [viewedPdfIndex, setViewedPdfIndex] = useState(0);
  const [shuffledPDFList, setShuffledPDFList] = useState([]);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [combinedFiles, setCombinedFiles] = useState(
    props?.combinedFiles ? props?.combinedFiles : {},
  );
  const [allPageCoordinates, setAllPageCoordinates] = useState(null);
  const [allCoordinate, setAllCoordinate] = useState(null);
  const coordinatesLoaded = useRef(false);
  // store values
  const otpCode = useSalesFormStore((state) => state.otpCode);

  const pdfListRef = useRef(pdfList);
  useEffect(() => {
    pdfListRef.current = pdfList; // Keep the ref updated
  }, [pdfList]);

  useEffect(() => {
    const keysWithTrueValue = [];
    for (const key in eSingendPdf) {
      if (eSingendPdf[key] === true) {
        keysWithTrueValue.push(key);
      }
    }
    if (keysWithTrueValue?.length > 0) {
      const data = pdfList?.map((pdf) => {
        if (keysWithTrueValue?.includes(pdf?.name)) {
          return {
            ...pdf,
            url: pdf?.url,
            submittedOn: new Date(),
            isESigned: true,
          };
        } else {
          return {
            ...pdf,
          };
        }
      });
      setPdfList(data);
      const checked = checkedPdfList?.map((pdf) => {
        if (keysWithTrueValue?.includes(pdf?.name)) {
          return {
            ...pdf,
            url: pdf?.url,
            submittedOn: new Date(),
            isESigned: true,
          };
        } else {
          return {
            ...pdf,
          };
        }
      });
      setCheckedPdfList(checked);
    }
  }, [eSingendPdf]);

  const checkPdfStatus = useCallback(
    async (application_name) => {
      const data = await getPdfStatus({
        editslug: props?.editslug,
        application_name: application_name,
      })
        .then((res) => {
          return res.pdf_status;
        })
        .catch((err) => {
          return false;
        });
      return data;
    },
    [props?.editslug],
  );

  const getAllSignCordinate = useCallback(async () => {
    const data = await signatureLocations({
      editslug: props?.editslug,
    })
      .then((response) => {
        if (props?.signerType) {
          if (props?.signerType === "First") {
            return response?.first;
          }
          if (props?.signerType === "Second") {
            return response?.second;
          }
        } else {
          return response?.first;
        }
      })
      .catch((error) => {
        return {};
      });
    return data;
  }, [props?.editslug, props?.signerType]);

  const getAllPageCoordinates = useCallback((allCoordinate) => {
    const addendumSignatures = allCoordinate?.addendums_signatures;
    if (addendumSignatures) {
      for (const key in addendumSignatures) {
        if (addendumSignatures.hasOwnProperty(key)) {
          const subObject = addendumSignatures[key];
          const nextIndex = Object.keys(subObject).length + 1;
          subObject[nextIndex.toString()] = [];
        }
      }
    }
    const coordinates = {
      ...allCoordinate?.application_signatures,
      ...addendumSignatures,
    };
    return coordinates;
  }, []);

  const getTimestamp = (date) => {
    const now = date ? new Date(date) : new Date();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezoneAbbreviation = momentTimezone
      .tz(momentTimezone.tz.guess())
      .format("z");
    const formattedTime = new Intl.DateTimeFormat("en-US", {
      timeZone: userTimezone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(now);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const timestamp = `${month}-${day}-${year} ${formattedTime} ${timezoneAbbreviation}`;
    return timestamp;
  };

  const checkIfPdfIsSubmitted = useCallback(() => {
    let isSubmitted = "";
    try {
      if (props?.signerType) {
        if (props?.signerType === "First") {
          const data = props?.signature?.filter(
            (item) => item?.signer_id === null,
          )?.[0];
          isSubmitted = data?.date_signed || "";
        }
        if (props?.signerType === "Second") {
          const data = props?.signature?.filter(
            (item) => item?.signer_id !== null,
          )?.[0];
          isSubmitted = data?.date_signed || "";
        }
      } else {
        isSubmitted = props?.signature?.[0]?.date_signed || "";
      }
    } catch (err) {
      isSubmitted = "";
      console.error("An error occurred:", err);
    }
    return isSubmitted;
  }, [props?.signerType, props?.signature]);

  useEffect(() => {
    var pusher = new Pusher(config.paymentcloud.PUSHER_KEY, {
      cluster: config.paymentcloud.PUSHER_CLUSTER,
      encrypted: true,
    });

    let channel_name = "pdf_generated_" + props?.editslug;
    var channel = pusher.subscribe(channel_name);
    channel.bind("app_pdf_generation_event", (data) => {
      fetchCombinedFiles();
    });
  }, []);

  const fetchCombinedFiles = async () => {
    const headers = {
      OtpCode: otpCode,
    };
    const appDataResponse = await getApplicationData(props?.editslug, {
      headers,
    });
    if (appDataResponse?.data?.combined_files) {
      setCombinedFiles(appDataResponse?.data?.combined_files);
    }
  };

  useEffect(() => {
    if (!isPdfLoading && Object.keys(combinedFiles)?.length === 0) {
      fetchCombinedFiles();
    }
  }, [isPdfLoading]);

  useEffect(() => {
    if (coordinatesLoaded.current) return;

    const loadCoordinates = async () => {
      const coordinateData = await getAllSignCordinate();
      const pageCoordinates = getAllPageCoordinates(coordinateData);
      setAllCoordinate(coordinateData);
      setAllPageCoordinates(pageCoordinates);
      coordinatesLoaded.current = true;
    };

    loadCoordinates();
  }, [getAllSignCordinate, getAllPageCoordinates]);

  useEffect(() => {
    if (allPageCoordinates === null || allCoordinate === null) {
      return; // Wait for coordinates to be loaded
    }

    if (!combinedFiles || Object.keys(combinedFiles).length === 0) {
      console.log("Combined files are not ready in useEffect");
      return;
    }

    fetchData();
    const intervalId = setInterval(() => {
      let re_check = false;
      if (pdfListRef?.current) {
        for (const pdf of pdfListRef.current) {
          if (!pdf.pdf_status) {
            re_check = true;
            break;
          }
        }
      }

      if (!re_check) {
        clearInterval(intervalId);
      } else {
        fetchData();
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [
    props?.bankList,
    props?.editslug,
    JSON.stringify(combinedFiles),
    JSON.stringify(props?.combinedFiles),
    allPageCoordinates,
    fetchData,
    combinedFiles,
    allCoordinate,
  ]);

  const fetchData = useCallback(async () => {
    if (!allPageCoordinates || !allCoordinate) {
      return;
    }

    if (!combinedFiles || Object.keys(combinedFiles).length === 0) {
      console.log("Combined files are not ready in fetchData");
      return;
    }

    console.log("Fetch data called");
    try {
      setIsPdfLoading(true);
      let bankList = props?.bankList;
      let editSlug = props?.editslug;
      // let combinedFiles = props?.combinedFiles;
      let submittedOn = checkIfPdfIsSubmitted();
      if (bankList?.length) {
        const pdfList = await Promise.all(
          bankList.map(async (key, value) => {
            const coordinateArray = [];
            const adminCoordinateArray = [];
            const isSigned = submittedOn
              ? props?.signerType === undefined
                ? await isSignedPdfExist(
                    stratusURL + "bank/" + editSlug + "/" + key.label,
                  )
                : await isSignedPdfExist(
                    stratusURL +
                      "bank/" +
                      editSlug +
                      "/" +
                      key.label +
                      "-" +
                      props?.signerType,
                  )
              : false;
            if (typeof combinedFiles?.[key.label] !== "undefined") {
              combinedFiles &&
                combinedFiles?.[key.label]?.forEach((i) => {
                  const innerFileKeys = allPageCoordinates?.[i]
                    ? Object.keys(allPageCoordinates[i])
                    : null;
                  const adminInnerFileKeys = allCoordinate?.[
                    "application_admin_signatures"
                  ]?.[i]
                    ? Object.keys(
                        allCoordinate?.["application_admin_signatures"]?.[i],
                      )
                    : null;
                  if (innerFileKeys) {
                    for (let key = 0; key < innerFileKeys.length - 1; key++) {
                      coordinateArray.push(
                        allPageCoordinates[i][innerFileKeys[key]],
                      );
                    }
                  }
                  if (adminInnerFileKeys) {
                    for (
                      let key = 0;
                      key < adminInnerFileKeys.length - 1;
                      key++
                    ) {
                      adminCoordinateArray.push(
                        allCoordinate?.["application_admin_signatures"]?.[i][
                          adminInnerFileKeys[key]
                        ],
                      );
                    }
                  }
                });

              console.log("coordinateArray");
              console.log(coordinateArray);
              console.log("adminCoordinateArray");
              console.log(adminCoordinateArray);
            } else {
              console.log("combinedFiles undefined for", key.label);
              console.log(combinedFiles);
            }
            return {
              name: key.label,
              url: stratusURL + "bank/" + editSlug + "/" + key.label,
              id: key.value,
              submittedOn: submittedOn,
              pdf_sign_coordinate: coordinateArray,
              admin_pdf_sign_coordinate: adminCoordinateArray,
              isESigned: isSigned,
              pdf_status: await checkPdfStatus(key.label),
            };
          }),
        );
        console.log("PDF LIST");
        console.log(pdfList);
        setPdfList(pdfList);
        setShuffledPDFList(pdfList);
      } else {
        setPdfList([]);
        setShuffledPDFList([]);
      }
      setIsPdfLoading(false);
    } catch (error) {
      console.error("Errors fetching data:", error);
    }
  }, [
    allPageCoordinates,
    allCoordinate,
    combinedFiles,
    props?.bankList,
    props?.editslug,
    props?.signerType,
    checkIfPdfIsSubmitted,
    checkPdfStatus,
  ]);

  useEffect(() => {
    if (!pdfList?.length) {
      props.handleChangeConsentPdf(true);
    } else {
      props.handleChangeConsentPdf(false);
      props.handleConsentPdfStatus({
        totalPdf: pdfList?.length,
        viewedPdf: checkedPdfList?.length,
      });
    }
  }, [pdfList]);

  const isSignedPdfExist = async (url) => {
    return await Axios.get(url + "/signed")
      .then((res) => {
        if (res?.status === 200) {
          return true;
        } else {
          return false;
        }
      })
      .catch(() => {
        return false;
      });
  };

  const rearrangePDF = (selectedIndex) => {
    if (selectedIndex >= 0 && selectedIndex < shuffledPDFList.length) {
      const rearrangedPDFList = [...shuffledPDFList]; // Create a copy of the original array
      const slicedPart = rearrangedPDFList.splice(0, selectedIndex); // Get the sliced part
      setShuffledPDFList([...rearrangedPDFList, ...slicedPart]);
    }
  };

  const handlePDFView = (url) => {
    // setPdf(url);
    const foundPdf = pdfList?.find((item) => item?.name === url?.name);
    setPdf(foundPdf);
    const pdfIndex = pdfList?.findIndex((item) => item?.name === url?.name);
    console.log({
      editSlug: props?.editslug,
      pdfURL: url,
      combinedFiles: combinedFiles,
      foundPdf: foundPdf,
      pdfIndex: pdfIndex,
    });
    TrackJS && TrackJS.track("PDFSignButton:click:reviewAndSign");
    rearrangePDF(pdfIndex);
  };

  const handleViewedPDF = (pdf, signedPdfStatus) => {
    if (!viewOnly) {
      const { signedPdfList, setSignedPdfList } = props;
      const list = new Set([...viewedPdfList, pdf]);
      setViewdPdfList(Array.from(list));
      setCheckedPdfList([...checkedPdfList, pdf]);
      let signedPdfArray = {
        signedPdfStatus: signedPdfStatus,
        signedPdf: pdf,
      };
      setSignedPdfList([...signedPdfList, signedPdfArray]);
      setESignedPdf({ ...eSingendPdf, [pdf?.name]: signedPdfStatus });
    }
    setPdf(null);
  };

  const isViewed = (pdf) => {
    const isPdf = viewedPdfList?.filter((item) => item?.name === pdf?.name);
    return viewOnly ? true : Boolean(isPdf?.length);
  };

  const handlePdfChecked = (event, pdf) => {
    const pdfWithoutSubmittedOn = removeSubmittedOnKey(pdf);
    if (event?.target?.checked) {
      setCheckedPdfList([...checkedPdfList, pdf]);
    } else {
      const remainingPdfList = checkedPdfList?.filter((item) => {
        const itemWithoutSubmittedOn = removeSubmittedOnKey(item);
        return (
          JSON.stringify(itemWithoutSubmittedOn) !==
          JSON.stringify(pdfWithoutSubmittedOn)
        );
      });
      setCheckedPdfList(remainingPdfList);
    }
  };

  useEffect(() => {
    props.handleChangeConsentPdf(checkedPdfList?.length);
    props.handleConsentPdfStatus({
      totalPdf: pdfList?.length,
      viewedPdf: checkedPdfList?.length,
    });
  }, [checkedPdfList]);

  const removeSubmittedOnKey = (obj) => {
    const { submittedOn, ...rest } = obj;
    return rest;
  };

  const isPdfChecked = (pdf) => {
    let isObjectInArray = false;
    const pdfWithoutSubmittedOn = removeSubmittedOnKey(pdf);
    for (const item of checkedPdfList) {
      const itemWithoutSubmittedOn = removeSubmittedOnKey(item);
      let isEqual = true;
      for (const key in pdf) {
        if (itemWithoutSubmittedOn[key] !== pdfWithoutSubmittedOn[key]) {
          isEqual = false;
          break;
        }
      }
      if (isEqual) {
        isObjectInArray = true;
        break;
      }
    }
    return isObjectInArray;
  };

  const bindPDF = (pdf, index) => {
    return (
      <div key={index} className={styles.pdfContainerItem}>
        <div className={styles.pdfHeader}>
          <div className={styles.pdfHeaderContent}>
            <img
              className={styles.pdfHeaderImage}
              src={stratusURL + "bank-image/" + pdf.name}
            ></img>
            <span>
              <p className={styles.pdfHeaderText}>{pdf.name}</p>
              {pdf?.submittedOn && pdf?.isESigned && (
                <span
                  className={styles.pdfHeaderSubText}
                >{`E-Signed on: ${getTimestamp(pdf.submittedOn)}`}</span>
              )}
            </span>
          </div>

          {pdf?.submittedOn ? (
            <div className="pdfdownload-icon">
              <a
                href={getPdfUrl(pdf?.url, props?.signerType)}
                // download={pdf.name}
                target="_blank"
                rel="noreferrer"
              >
                <ButtonIcon size="small">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14 9V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H2.5C2.36739 13.5 2.24021 13.4473 2.14645 13.3536C2.05268 13.2598 2 13.1326 2 13V9C2 8.86739 2.05268 8.74021 2.14645 8.64645C2.24021 8.55268 2.36739 8.5 2.5 8.5C2.63261 8.5 2.75979 8.55268 2.85355 8.64645C2.94732 8.74021 3 8.86739 3 9V12.5H13V9C13 8.86739 13.0527 8.74021 13.1464 8.64645C13.2402 8.55268 13.3674 8.5 13.5 8.5C13.6326 8.5 13.7598 8.55268 13.8536 8.64645C13.9473 8.74021 14 8.86739 14 9ZM7.64625 9.35375C7.69269 9.40024 7.74783 9.43712 7.80853 9.46228C7.86923 9.48744 7.93429 9.50039 8 9.50039C8.06571 9.50039 8.13077 9.48744 8.19147 9.46228C8.25217 9.43712 8.30731 9.40024 8.35375 9.35375L10.8538 6.85375C10.9002 6.8073 10.9371 6.75214 10.9622 6.69145C10.9873 6.63075 11.0003 6.5657 11.0003 6.5C11.0003 6.4343 10.9873 6.36925 10.9622 6.30855C10.9371 6.24786 10.9002 6.1927 10.8538 6.14625C10.8073 6.09979 10.7521 6.06294 10.6914 6.0378C10.6308 6.01266 10.5657 5.99972 10.5 5.99972C10.4343 5.99972 10.3692 6.01266 10.3086 6.0378C10.2479 6.06294 10.1927 6.09979 10.1462 6.14625L8.5 7.79313V2C8.5 1.86739 8.44732 1.74021 8.35355 1.64645C8.25979 1.55268 8.13261 1.5 8 1.5C7.86739 1.5 7.74021 1.55268 7.64645 1.64645C7.55268 1.74021 7.5 1.86739 7.5 2V7.79313L5.85375 6.14625C5.75993 6.05243 5.63268 5.99972 5.5 5.99972C5.36732 5.99972 5.24007 6.05243 5.14625 6.14625C5.05243 6.24007 4.99972 6.36732 4.99972 6.5C4.99972 6.63268 5.05243 6.75993 5.14625 6.85375L7.64625 9.35375Z"
                      fill="#3A383F"
                    />
                  </svg>
                </ButtonIcon>
              </a>
            </div>
          ) : (
            <div className="pdfdownload-icon">
              <Button
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14 9V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H2.5C2.36739 13.5 2.24021 13.4473 2.14645 13.3536C2.05268 13.2598 2 13.1326 2 13V9C2 8.86739 2.05268 8.74021 2.14645 8.64645C2.24021 8.55268 2.36739 8.5 2.5 8.5C2.63261 8.5 2.75979 8.55268 2.85355 8.64645C2.94732 8.74021 3 8.86739 3 9V12.5H13V9C13 8.86739 13.0527 8.74021 13.1464 8.64645C13.2402 8.55268 13.3674 8.5 13.5 8.5C13.6326 8.5 13.7598 8.55268 13.8536 8.64645C13.9473 8.74021 14 8.86739 14 9ZM7.64625 9.35375C7.69269 9.40024 7.74783 9.43712 7.80853 9.46228C7.86923 9.48744 7.93429 9.50039 8 9.50039C8.06571 9.50039 8.13077 9.48744 8.19147 9.46228C8.25217 9.43712 8.30731 9.40024 8.35375 9.35375L10.8538 6.85375C10.9002 6.8073 10.9371 6.75214 10.9622 6.69145C10.9873 6.63075 11.0003 6.5657 11.0003 6.5C11.0003 6.4343 10.9873 6.36925 10.9622 6.30855C10.9371 6.24786 10.9002 6.1927 10.8538 6.14625C10.8073 6.09979 10.7521 6.06294 10.6914 6.0378C10.6308 6.01266 10.5657 5.99972 10.5 5.99972C10.4343 5.99972 10.3692 6.01266 10.3086 6.0378C10.2479 6.06294 10.1927 6.09979 10.1462 6.14625L8.5 7.79313V2C8.5 1.86739 8.44732 1.74021 8.35355 1.64645C8.25979 1.55268 8.13261 1.5 8 1.5C7.86739 1.5 7.74021 1.55268 7.64645 1.64645C7.55268 1.74021 7.5 1.86739 7.5 2V7.79313L5.85375 6.14625C5.75993 6.05243 5.63268 5.99972 5.5 5.99972C5.36732 5.99972 5.24007 6.05243 5.14625 6.14625C5.05243 6.24007 4.99972 6.36732 4.99972 6.5C4.99972 6.63268 5.05243 6.75993 5.14625 6.85375L7.64625 9.35375Z"
                      fill="#3A383F"
                    />
                  </svg>
                }
                type="button"
                variant="ghost"
                onClick={() => {
                  window.open(pdf?.url, "_blank");
                }}
              />
            </div>
          )}
        </div>
        <div className={styles.pdfButtonContainer}>
          {!pdf?.submittedOn ? (
            <>
              {pdf.pdf_status ? (
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() => !props.isDisable && handlePDFView(pdf)}
                  disabled={props.isDisable}
                  data-tip={props.isDisable ? SignatureTooltip : ""}
                >
                  Review & Sign
                </Button>
              ) : (
                <Spinner size={25} />
              )}
            </>
          ) : !pdf?.isESigned ? (
            <span className="esignedpdf">Not Signed</span>
          ) : (
            <span className="esignedpdf">Signed</span>
          )}
        </div>
      </div>
    );
  };

  const bindNonEMSPdf = () => {
    const nonEMSPdf = pdfList?.filter((pdf) => pdf?.name !== "EMS");
    return nonEMSPdf?.map((pdf, index) => bindPDF(pdf, `nonEMS-${index}`));
  };

  const bindEMSPdf = () => {
    const emsPdf = pdfList?.filter((pdf) => pdf?.name === "EMS");
    return emsPdf?.map((pdf, index) => bindPDF(pdf, `ems-${index}`));
  };

  useEffect(() => {
    if (viewedPdfIndex > 0) {
      if (viewedPdfIndex < pdfList.length) {
        setPdf(shuffledPDFList?.[viewedPdfIndex]);
      } else {
        setPdf(null);
      }
    }
  }, [viewedPdfIndex]);

  console.log("=== DIGITAL SIGNATURE DEBUG ===");
  console.log("PDF List:", pdfList);
  console.log("All Page Coordinates:", !!allPageCoordinates);
  console.log("All Coordinate:", !!allCoordinate);
  console.log("Combined Files:", combinedFiles);

  return (
    <>
      {isPdfLoading ||
      Object.keys(combinedFiles)?.length === 0 ||
      !allPageCoordinates ||
      !allCoordinate ? (
        <div className={styles.pdfLoader}>
          <Spinner />
        </div>
      ) : (
        <div
          className={props.isDisable ? "Disabledthnakyoupdf mt-4" : "mt-3"}
          data-tip={props.isDisable ? SignatureTooltip : ""}
        >
          <ReactTooltip />
          <div className={styles.pdfContainer}>
            {/* {bindEMSPdf()}
            {bindNonEMSPdf()} */}
            {pdfList
              ?.filter((pdf) => pdf?.name === "EMS")
              ?.map((pdf) => (
                <PDFItem
                  key={pdf?.name}
                  pdf={pdf}
                  signerType={props?.signerType}
                  isDisable={props?.isDisable}
                  handlePDFView={handlePDFView}
                />
              ))}

            {pdfList
              ?.filter((pdf) => pdf?.name !== "EMS")
              ?.map((pdf) => (
                <PDFItem
                  key={pdf?.name}
                  pdf={pdf}
                  signerType={props?.signerType}
                  isDisable={props?.isDisable}
                  handlePDFView={handlePDFView}
                />
              ))}
          </div>
          {pdf && (
            <ViewPdfModal
              viewOnly={viewOnly}
              handleViewedPDF={handleViewedPDF}
              setPdf={setPdf}
              pdf={pdf}
              signature={props?.sign}
              editSlug={props?.editslug}
              signedName={props?.signedName}
              signerType={props?.signerType}
              setViewedPdfIndex={setViewedPdfIndex}
            />
          )}
        </div>
      )}
    </>
  );
};

const PDFItem = ({ pdf, signerType, isDisable, handlePDFView }) => {
  const getTimestamp = (date) => {
    const now = date ? new Date(date) : new Date();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezoneAbbreviation = momentTimezone
      .tz(momentTimezone.tz.guess())
      .format("z");
    const formattedTime = new Intl.DateTimeFormat("en-US", {
      timeZone: userTimezone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(now);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const timestamp = `${month}-${day}-${year} ${formattedTime} ${timezoneAbbreviation}`;
    return timestamp;
  };

  return (
    <div className={styles.pdfContainerItem}>
      <div className={styles.pdfHeader}>
        <div className={styles.pdfHeaderContent}>
          <img
            className={styles.pdfHeaderImage}
            src={stratusURL + "bank-image/" + pdf.name}
          ></img>
          <div className={styles.pdfHeaderTextContainer}>
            <p className={styles.pdfHeaderText}>{pdf.name}</p>

            {pdf?.submittedOn && pdf?.isESigned && (
              <span className={styles.pdfHeaderSubText}>
                {`E-Signed on: ${getTimestamp(pdf.submittedOn)}`}
              </span>
            )}
          </div>
        </div>

        {pdf?.submittedOn ? (
          <div className="pdfdownload-icon">
            <a
              href={getPdfUrl(pdf?.url, signerType)}
              // download={pdf.name}
              target="_blank"
              rel="noreferrer"
            >
              <ButtonIcon size="small">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14 9V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H2.5C2.36739 13.5 2.24021 13.4473 2.14645 13.3536C2.05268 13.2598 2 13.1326 2 13V9C2 8.86739 2.05268 8.74021 2.14645 8.64645C2.24021 8.55268 2.36739 8.5 2.5 8.5C2.63261 8.5 2.75979 8.55268 2.85355 8.64645C2.94732 8.74021 3 8.86739 3 9V12.5H13V9C13 8.86739 13.0527 8.74021 13.1464 8.64645C13.2402 8.55268 13.3674 8.5 13.5 8.5C13.6326 8.5 13.7598 8.55268 13.8536 8.64645C13.9473 8.74021 14 8.86739 14 9ZM7.64625 9.35375C7.69269 9.40024 7.74783 9.43712 7.80853 9.46228C7.86923 9.48744 7.93429 9.50039 8 9.50039C8.06571 9.50039 8.13077 9.48744 8.19147 9.46228C8.25217 9.43712 8.30731 9.40024 8.35375 9.35375L10.8538 6.85375C10.9002 6.8073 10.9371 6.75214 10.9622 6.69145C10.9873 6.63075 11.0003 6.5657 11.0003 6.5C11.0003 6.4343 10.9873 6.36925 10.9622 6.30855C10.9371 6.24786 10.9002 6.1927 10.8538 6.14625C10.8073 6.09979 10.7521 6.06294 10.6914 6.0378C10.6308 6.01266 10.5657 5.99972 10.5 5.99972C10.4343 5.99972 10.3692 6.01266 10.3086 6.0378C10.2479 6.06294 10.1927 6.09979 10.1462 6.14625L8.5 7.79313V2C8.5 1.86739 8.44732 1.74021 8.35355 1.64645C8.25979 1.55268 8.13261 1.5 8 1.5C7.86739 1.5 7.74021 1.55268 7.64645 1.64645C7.55268 1.74021 7.5 1.86739 7.5 2V7.79313L5.85375 6.14625C5.75993 6.05243 5.63268 5.99972 5.5 5.99972C5.36732 5.99972 5.24007 6.05243 5.14625 6.14625C5.05243 6.24007 4.99972 6.36732 4.99972 6.5C4.99972 6.63268 5.05243 6.75993 5.14625 6.85375L7.64625 9.35375Z"
                    fill="#3A383F"
                  />
                </svg>
              </ButtonIcon>
            </a>
          </div>
        ) : (
          <div className="pdfdownload-icon">
            <Button
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14 9V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H2.5C2.36739 13.5 2.24021 13.4473 2.14645 13.3536C2.05268 13.2598 2 13.1326 2 13V9C2 8.86739 2.05268 8.74021 2.14645 8.64645C2.24021 8.55268 2.36739 8.5 2.5 8.5C2.63261 8.5 2.75979 8.55268 2.85355 8.64645C2.94732 8.74021 3 8.86739 3 9V12.5H13V9C13 8.86739 13.0527 8.74021 13.1464 8.64645C13.2402 8.55268 13.3674 8.5 13.5 8.5C13.6326 8.5 13.7598 8.55268 13.8536 8.64645C13.9473 8.74021 14 8.86739 14 9ZM7.64625 9.35375C7.69269 9.40024 7.74783 9.43712 7.80853 9.46228C7.86923 9.48744 7.93429 9.50039 8 9.50039C8.06571 9.50039 8.13077 9.48744 8.19147 9.46228C8.25217 9.43712 8.30731 9.40024 8.35375 9.35375L10.8538 6.85375C10.9002 6.8073 10.9371 6.75214 10.9622 6.69145C10.9873 6.63075 11.0003 6.5657 11.0003 6.5C11.0003 6.4343 10.9873 6.36925 10.9622 6.30855C10.9371 6.24786 10.9002 6.1927 10.8538 6.14625C10.8073 6.09979 10.7521 6.06294 10.6914 6.0378C10.6308 6.01266 10.5657 5.99972 10.5 5.99972C10.4343 5.99972 10.3692 6.01266 10.3086 6.0378C10.2479 6.06294 10.1927 6.09979 10.1462 6.14625L8.5 7.79313V2C8.5 1.86739 8.44732 1.74021 8.35355 1.64645C8.25979 1.55268 8.13261 1.5 8 1.5C7.86739 1.5 7.74021 1.55268 7.64645 1.64645C7.55268 1.74021 7.5 1.86739 7.5 2V7.79313L5.85375 6.14625C5.75993 6.05243 5.63268 5.99972 5.5 5.99972C5.36732 5.99972 5.24007 6.05243 5.14625 6.14625C5.05243 6.24007 4.99972 6.36732 4.99972 6.5C4.99972 6.63268 5.05243 6.75993 5.14625 6.85375L7.64625 9.35375Z"
                    fill="#3A383F"
                  />
                </svg>
              }
              type="button"
              variant="ghost"
              onClick={() => {
                window.open(pdf?.url, "_blank");
              }}
            />
          </div>
        )}
      </div>
      <div className={styles.pdfButtonContainer}>
        {!pdf?.submittedOn ? (
          <>
            {pdf.pdf_status ? (
              <Button
                type="button"
                variant="ghost"
                onClick={() => !isDisable && handlePDFView(pdf)}
                disabled={isDisable}
                data-tip={isDisable ? SignatureTooltip : ""}
              >
                Review & Sign
              </Button>
            ) : (
              <Spinner size={25} />
            )}
          </>
        ) : !pdf?.isESigned ? (
          <span className="esignedpdf">Not Signed</span>
        ) : (
          <span className="esignedpdf">Signed</span>
        )}
      </div>
    </div>
  );
};

export default DigitalSignature;
